import React from "react";
import { Link } from "react-router-dom";

interface BreadCrumbsProps {
  title: string;
  items: Array<{
    name: string;
    route: string;
  }>;
}

const BreadCrumbsLink: React.FC<BreadCrumbsProps> = ({ title, items }) => {
  return (
    <div className="row">
      <div className="col-12">
        <div className="page-title-box d-sm-flex align-items-center justify-content-between">
          <h4 className="mb-sm-0 font-700">{title}</h4>
          <div className="page-title-right">
            <ol className="breadcrumb m-0">
              {items.map((item) => {
                return (
                  <Link
                    to={item.route}
                    className={`breadcrumb-item ${
                      title === item.name ? "active" : ""
                    }`}
                  >
                    <span data-key={item.route.replace("/", "")}>
                      {item.name}
                    </span>
                  </Link>
                );
              })}
            </ol>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BreadCrumbsLink;
